"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageDialog = void 0;
const react_1 = __importStar(require("react"));
const dialog_1 = require("../../components/dialog/dialog");
const react_intl_1 = require("react-intl");
exports.MessageDialog = react_1.forwardRef(function MessageDialog({ title, content, onClose }, ref) {
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: title, onConfirm: onClose, showClose: false, confirmLabel: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_MESSAGE_DIALOG_BTN_CLOSE", defaultMessage: "Zav\u0159\u00EDt" }) }, () => react_1.default.createElement(react_1.default.Fragment, null, content)));
});
//# sourceMappingURL=message-dialog.js.map